import { AxiosInstancePlus } from '@tencent/oneid-request';
import { IResponseType } from 'common/constants/Types';
import { http } from 'common/http';
import BaseApi from 'common/http/BaseApi';

class UsersApi extends BaseApi {
  public axiosInstance: AxiosInstancePlus = http;

  public prefixURL = '/admin/v2/users';

  saveAvatar(avatar_url: string): Promise<IResponseType> {
    return this.axiosInstance.post(`${this.prefixURL}/avatar`, { avatar_url });
  }
}
export default new UsersApi();
